<p-dialog [(visible)]="displayDialog" [style]="{ width: '50vw' }" [modal]="true" [draggable]="false" [resizable]="false"
    [closable]="true" (onHide)="onDialogClosed()" [header]="esEdicion ? 'Editar Guión' : 'Nuevo Guión'">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" appPermissionControl="P275F0001">
        <div class="form-row">
            <div class="form-field">
                <input pInputText type="text" formControlName="sClaveCues" class="form-control"
                    [placeholder]="cuestionario?.sClaveCues" disabled appPermissionControl="P275K0001">
                <label>Clave Cuestionario</label>
            </div>
            <div class="form-field">
                <input pInputText type="number" formControlName="iNumPreg" class="form-control"
                    [placeholder]="preguntaSeleccionada?.iNumPreg" disabled appPermissionControl="P275K0002">
                <label>N° Pregunta</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <input pInputText type="number" formControlName="iNumGuia" class="form-control"
                    placeholder="N° Guión" [disabled]="esEdicion" appPermissionControl="P275K0003">
                <label>N° Guión</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <textarea pInputTextarea formControlName="sTexto" class="form-control"
                    rows="3" appPermissionControl="P275K0004"></textarea>
                <label>Texto</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <label for="sTabla">Tabla</label>
                <p-dropdown id="sTabla" formControlName="sTabla" [options]="tablas" [filter]="true" [showClear]="true"
                    placeholder="Seleccione una tabla" appendTo="body" [loading]="loading" class="w-100" appPermissionControl="P275K0005">
                </p-dropdown>
            </div>
            <div class="form-field">
                <label for="sTipo">Tipo</label>
                <p-dropdown id="sTipo" formControlName="sTipo" [options]="tipos" [filter]="true" [showClear]="true"
                    placeholder="Seleccione un tipo" appendTo="body" [loading]="loading" class="w-100" appPermissionControl="P275K0006">
                </p-dropdown>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <label for="sCampo">Campo</label>
                <p-dropdown id="sCampo" formControlName="sCampo" [options]="campos" [filter]="true" [showClear]="true"
                    placeholder="Seleccione un campo" appendTo="body" [loading]="loading" class="w-100" appPermissionControl="P275K0007">
                </p-dropdown>
            </div>
        </div>

        <div class="button-section mt-3">
            <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading" appPermissionControl="P275B0001">
                <mat-icon *ngIf="!loading">save</mat-icon>
                <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8"
                    fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                {{ esEdicion ? 'Actualizar' : 'Guardar' }}
            </button>
        </div>
    </form>
</p-dialog>

<p-toast position="bottom-right"></p-toast> 